import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
    .event-page {
        .event-page-area {
            background-color: #F6F9FF;
            padding: 70px 0;

            h4.tab-title {
                color: ${colors.black1};
                font-weight: 600;
                margin-bottom: 25px;

                @media(max-width: 575px) {
                    margin-bottom: 15px;
                    font-size: 20px;
                }
            }

            .event-box {
                .event-img {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                    border-left: 1px solid rgba(0, 0, 0, 0.2);
                    box-shadow: -5px 5px 5px rgba(0, 0, 0, 0.3);

                    a {
                        img {
                            border-radius: 5px;
                            width: 100%;
                            height: auto;
                        }
                    }

                    @media(max-width: 991px) {
                        /* Ensure images are visible on smaller screens */
                        display: block;
                    }
                }
            }
        }

        /* Media Queries */
        @media(max-width: 767px) {
            .event-box {
                .event-img {
                    a img {
                        border-radius: 5px;
                        max-width: 100%; /* Ensure images don't overflow */
                    }
                }
            }
        }
    }
`;
